import React, { useEffect, useState } from "react";
import Button from "../Button/Button";
import "./Card.css";
import DeleteButton from "../DeleteButton/DeleteButton";
import { useNavigate } from "react-router-dom";
import { useListManager } from "../../contexts/list.manager";

const Card = (props) => {
  const [cardHeight, setCardHeight] = useState("108px");
  const navigate = useNavigate();
  const { handleLineClick } = useListManager();

  useEffect(() => {
    if (props.showDetails === true) setCardHeight("290px");
    if (props.showDetails === false) setCardHeight("108px");
  }, [props.showDetails]);

  useEffect(() => {
    setCardHeight("108px");
  }, [props.closeCard]);

  const handleClick = () => {
    if (props.disableCardExpansion) return;

    if (cardHeight === "108px") {
      setCardHeight("290px");
      handleLineClick(props.data, true);
    }

    if (cardHeight === "290px") {
      setCardHeight("108px");
      handleLineClick(null, true);
    }
  };

  const handleEdit = () => {
    if (props.edit) props.edit();
    if (props.navigateOnEdit)
      navigate(props.navigateOnEdit, { state: props.data });
    setCardHeight("108px");
  };

  const handleDelete = () => {
    if (props.delete) props.delete();
    if (props.navigateOnDelete) navigate(props.navigateOnDelete);
    setCardHeight("108px");
  };

  return (
    <div className="card-container" style={{ height: cardHeight }}>
      <div className="card-content-container" onClick={() => handleClick()}>
        {props.icon && <div className="card-icon">{props.icon}</div>}
        <div>
          {cardHeight === "108px" && props.children?.length ? (
            <React.Fragment>
              <div>{props.children[0]}</div>
              <div>{props.children[1]}</div>
              <div>{props.children[2]}</div>
              <div>{props.children[3]}</div>
            </React.Fragment>
          ) : (
            props.children
          )}
        </div>
      </div>
      {cardHeight === "290px" && (
        <div className="card-buttons-container">
          {!props.hideCardEditDeleteButtons && (
            <React.Fragment>
              <Button
                className={"button-blue card-buttons"}
                label={"Editar"}
                action={"edit"}
                onClick={handleEdit}
              />
              <DeleteButton
                askForPassword={props.askForPasswordOnDelete}
                handleDelete={handleDelete}
                className={"button-white card-buttons"}
              />
            </React.Fragment>
          )}
          {props.aditionalButton1 && (
            <div>
              {props.aditionalButton1}
              {props.aditionalButton2}
              {props.aditionalButton3}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Card;
